import { resolveProductPrice } from "../../utils/product.mjs";
const allowedCodes = /(color|colour)/gi;
export const extractConfigurableProductListingOptions = (apiItem) => {
  if (apiItem.__typename === "ConfigurableProduct" && apiItem.configurable_options?.length) {
    const options = apiItem.configurable_options?.find(
      (option) => !!option?.attribute_code?.toLowerCase().match(allowedCodes)
    )?.values?.map((option) => {
      const selectedVariant = apiItem.variants?.find(
        (variant) => variant?.attributes?.find(
          (attribute) => attribute?.uid === option?.uid
        )
      );
      return {
        color: option?.swatch_data?.value,
        thumb: {
          src: selectedVariant?.product?.image?.url || "",
          alt: selectedVariant?.product?.image?.label || ""
        },
        name: selectedVariant?.product?.name || "",
        price: selectedVariant?.product && resolveProductPrice(selectedVariant?.product) || 0,
        slug: apiItem.url_key + "/var/" + selectedVariant?.product?.url_key
      };
    }) || [];
    return [
      {
        thumb: {
          src: apiItem?.thumbnail?.url || "",
          alt: apiItem?.thumbnail?.label || ""
        },
        name: apiItem?.name || "",
        price: resolveProductPrice(apiItem),
        slug: apiItem.url_key || ""
      },
      ...options
    ];
  }
  return [
    {
      thumb: {
        src: apiItem?.thumbnail?.url || "",
        alt: apiItem?.thumbnail?.label || ""
      },
      name: apiItem?.name || "",
      price: resolveProductPrice(apiItem),
      slug: apiItem.url_key || ""
    }
  ];
};
export function resolveStockItem(apiItem) {
  if (apiItem.__typename === "ConfigurableProduct" && apiItem.variants?.length) {
    return apiItem.variants.reduce((accu, variant) => {
      const stock = variant?.product?.only_x_left_in_stock || 0;
      return accu + stock;
    }, 0);
  }
  return 0;
}
export function resolveNewInInterval(days) {
  const newInProductsDate = /* @__PURE__ */ new Date();
  newInProductsDate.setDate(newInProductsDate.getDate() - days);
  return newInProductsDate;
}
export function createdAtFilterOption(date) {
  const parsedDate = date.toISOString().split("T")[0];
  return {
    created_at: {
      gteq: parsedDate
    }
  };
}
export function resolveNewInRangeFilterOption(days) {
  const newInProductsDate = resolveNewInInterval(days);
  return createdAtFilterOption(newInProductsDate);
}
